
<ul class="navbar-nav flex-row mr-3 " style="cursor: pointer;" >

  <li class="nav-item dropdown dropdown-list" dropdown>
  <a class="nav-link dropdown-toggle dropdown-toggle-nocaret" dropdownToggle>
    <em class="icon-bell mr-2"></em>
    <span class="badge badge-danger">{{notifications?.length}}</span>
  </a>
  <!-- START Dropdown menu-->
  <div *dropdownMenu class="dropdown-menu dropdown-menu-right" style="width: 380px;">
    <div class="dropdown-item">
      <!-- START list group-->
      <div class="list-group">

        <div class="list-group-item list-group-item-action" >
          <div class="media" style="cursor: pointer;" (click)="markAllAsSeen()">
            <div class="align-self-start">
              <em class="fas fa-check-double fa-1x text-success"></em>
            </div>
            <div class="media-body">
              <p i18n>Tout marquer comme lu</p>
            </div>
          </div>
        </div>

        <div class="list-group-item list-group-item-action" *ngFor="let notification of notificationsToShow;let i = index;">
          <div class="media">
            <div class="media-body">
              <p class="m-0"><a (click)="onNotificationClick(notification)">{{notification}}</a></p>
              <p class="m-0 text-muted text-sm">{{notification?.creationDate | date:'dd-MM-yyyy HH:mm'}}</p>
            </div>
          </div>
        </div>

        <div class="list-group-item list-group-item-action">
          <div class="media" style="cursor: pointer;">
            <div class="align-self-start mr-2">
              <em class="fas fa-info-circle fa-2x text-info"></em>
            </div>
            <div class="media-body">
              <p class="m-0" (click)="showNotifications()" i18n>Voir Tout</p>
              <p class="m-0 text-muted text-sm"><span i18n>Notifications</span> ({{notifications?.length}} <span i18n>non lus</span>)</p>
            </div>
          </div>
        </div>

      </div>
      <!-- END list group-->
    </div>
  </div>
  <!-- END Dropdown menu-->
</li>

</ul>
